import React from 'react';
import {
    Select,
    TextField,
    Stack
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const variantConditions = [
    { label: 'of all variants', value: 'AllVariants' },
    { label: 'of any variant', value: 'AnyVariant' },
    { label: 'of no variants', value: 'NoVariants' }
];

const percentageConditions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is not equal to', value: 'NotEqualTo' },
    { label: 'is greater than', value: 'GreaterThan' },
    { label: 'is greater than or equal to', value: 'GreaterThanOrEqual' },
    { label: 'is less than or equal to', value: 'LessThanOrEqual' },
    { label: 'is less than', value: 'LessThan' }
];

class ProductPricePercentageOfCompareAtPriceFilterComponent extends React.Component {
    state = {};

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={variantConditions}
                    value={this.props.filter.variantCondition}
                    onChange={(selected) => this.onVariantConditionChange(selected)}
                />
                <Select
                    options={percentageConditions}
                    value={this.props.filter.percentageCondition}
                    onChange={(selected) => this.onPercentageConditionChange(selected)}
                />
                <TextField
                    placeholder="Percentage"
                    type="number"
                    inputMode="decimal"
                    suffix="%"
                    value={this.props.filter.percentage.toString()}
                    onChange={(newValue) => this.onPercentageChange(newValue)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onVariantConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.variantCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onPercentageConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.percentageCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onPercentageChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.percentage = parseFloat(newValue);

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductPricePercentageOfCompareAtPriceFilterComponent;
